import { useForm } from "react-hook-form";
import { JVDropdown } from "../../shared/JVDropdown"
import { JVInput } from "../../shared/JVInput"
import { yupResolver } from "@hookform/resolvers/yup";
import { JVDate } from "../../shared/JVDate";
import * as yup from "yup";
import { JVRadioBtn } from "../../shared/JVRadioBtn";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { IBranchMastDropdown, IDepartmentDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { JVInputMask } from "../../shared/JVInputMask";

const schema = yup.object({
    emp_Code: yup.string().required("Employee Code is required").min(3),
    first_Name: yup.string().required("First Name is required").min(3),
    last_Name: yup.string().nullable(),
    mob: yup.string().required("Mobile is required").min(10),
    email: yup.string().email("please enter valid email").nullable(),
    branch_ID: yup.number().nullable(),
    adhar: yup.string().nullable(),
    pan: yup.string().nullable(),
    dateofJoining: yup.string().nullable(),
    endDate: yup.string().nullable(),
    salary: yup.number().nullable().typeError('Only number is allowed'),
    department: yup.number().nullable(),
    empStatus: yup.string().nullable(),
    createdBy: yup.number().nullable(),
    createdOn: yup.date().nullable(),
    teamLead: yup.number().nullable(),
    hangout: yup.string().email("please enter valid email").nullable(),
});

export interface IEmptyEmployee {
    emp_ID?: number,
    emp_Code?: string,
    first_Name?: string,
    last_Name?: string,
    mob?: string,
    email?: string,
    branch_ID?: number,
    adhar?: string,
    pan?: string,
    dateofJoining?: Date | null | string,
    endDate?: Date | null | string,
    salary?: number,
    empStatus?: string | boolean,
    createdBy?: number | null,
    createdOn?: Date | null,
    teamLead?: number,
    department?: number,
    hangout?: string,
    teamLead_Name?: string,
    branch_Name?: string,
    department_Name?: string,
}
export const EmptyEmployee: IEmptyEmployee = {
    emp_Code: "",
    first_Name: "",
    last_Name: "",
    mob: "",
    email: "",
    branch_ID: 0,
    adhar: "",
    pan: "",
    dateofJoining: null,
    endDate: null,
    salary: 0,
    empStatus: true,
    createdBy: null,
    createdOn: null,
    teamLead: 0,
    department: 0,
    hangout: "",
}

interface IProps {
    singleData: IEmptyEmployee,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

interface Users {
    branch_ID?: number,
    login_ID?: number,
    user_Name?: string,
}


export const Form = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [department, setDepartment] = useState<Array<IDepartmentDropdown>>();
    const [teamLead, setTeamLead] = useState<Array<Users>>();
    const [saveDis, setSaveDis] = useState(false);

    const { control, handleSubmit, formState: { errors }, watch, reset, setValue } = useForm<IEmptyEmployee>({
        resolver: yupResolver(schema),
        shouldFocusError: false,
        defaultValues: props.singleData
    });

    const loadBranches = async () => {
        const response = await Fetch("Dropdown/branches", "GET", null, null, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            // data.unshift(emptyData);
            setBranches(data);
        }
    }

    const loadDepartment = async () => {
        // department
        const response = await Fetch("Dropdown/department", "GET", null, null, null);
        if (response) {
            const data: Array<IDepartmentDropdown> = await response.json();
            const emptyData = {
                department_ID: 0,
                department_Name: "-- SELECT --"
            };
            // data.unshift(emptyData);
            setDepartment(data);
        }
    }

    const loadUsers = async (branch_ID: number | undefined) => {
        const response = await Fetch("Dropdown/UsersByBranch", "GET", null, `branch_ID=${branch_ID}`, null);
        if (response) {
            const data: Array<Users> = await response.json();
            setTeamLead(data);
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "branch_ID") {
                if (value.branch_ID != 0) {
                    // setDisable({branch:false, teamManage:false});
                    loadUsers(value.branch_ID);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadBranches();
        loadDepartment();
        if (props.singleData.branch_ID) loadUsers(props.singleData.branch_ID);
        if (props.singleData.dateofJoining === "") {
            props.singleData.dateofJoining = null;
        }
        if (props.singleData.endDate === "") {
            props.singleData.endDate = null;
        }
        props.singleData.empStatus ? props.singleData.empStatus = "Active" : props.singleData.empStatus = "InActive";
        reset(props.singleData);
    }, [props.open]);

    const saveToDB = async (data: any) => {
        const method = props.singleData.emp_Code != "" ? "PUT" : "POST";
        const message = props.singleData.emp_Code != "" ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("tbl_Employee", method, data, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
    }

    const getEmployee = async () => {
        const response = await Fetch("tbl_Employee/byId", "GET", null, `Emp_ID=${props.singleData.emp_ID}`, props.toast);
        if (response) {
            const data: IEmptyEmployee = await response.json();
            // if (typeof(data.dateofJoining) === "string") {
            //     let dateArray = data.dateofJoining.split("/");
            //     let month = parseInt(dateArray[0]) - 1; 
            //     let day = parseInt(dateArray[1]);
            //     let year = parseInt(dateArray[2]);
            //     data.dateofJoining = new Date(year, month, day);
            // }
            if (typeof (data.dateofJoining) === "string") {
                let dateArray = data.dateofJoining.split("/");
                let day = parseInt(dateArray[0]);
                let month = parseInt(dateArray[1]) - 1;
                let year = parseInt(dateArray[2]);

                data.dateofJoining = new Date(year, month, day);
            }
            if (typeof (data.endDate) === "string") {
                let dateArray = data.endDate.split("/");
                let day = parseInt(dateArray[0]);
                let month = parseInt(dateArray[1]) - 1;
                let year = parseInt(dateArray[2]);
                data.endDate = new Date(year, month, day);
            }
            data.empStatus ? data.empStatus = "Active" : data.empStatus = "InActive";
            // if (typeof(data.endDate)=== "string") {
            //     data.endDate = null;
            // }
            reset(data);
           
        }
    }


    useEffect(() => {
        if (props.singleData.emp_ID) {
            getEmployee();

        }
    }, [props.singleData]);


    function onSubmit(data: IEmptyEmployee) {
        let body: any = data;
        if (body.empStatus != "") {
            body.empStatus === "Active" ? body.empStatus = true : body.empStatus = false;
        } else {
            body.empStatus = false;
        }
        if (body.dateofJoining != null) {
            let datee = new Date(body.dateofJoining);
            if (datee) {
                let day = datee.getDate() < 10 ? `0${datee.getDate()}` : datee.getDate();
                let mnth = datee.getMonth() + 1 < 10 ? `0${datee.getMonth() + 1}` : datee.getMonth() + 1;
                let yr = datee.getFullYear();
                body.dateofJoining = day + "/" + mnth + "/" + yr;
            }
        }
        if (body.endDate != null) {
            let datee = new Date(body.endDate);
            if (datee) {
                let day = datee.getDate() < 10 ? `0${datee.getDate()}` : datee.getDate();
                let mnth = datee.getMonth() + 1 < 10 ? `0${datee.getMonth() + 1}` : datee.getMonth() + 1;
                let yr = datee.getFullYear();
                body.endDate = day + "/" + mnth + "/" + yr;
            }
        }
        // if (body.endDate.trim()==="") {
        //     body.endDate = null;
        //     }

        setSaveDis(true);
        saveToDB(data);
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyEmployee);
        setSaveDis(false);
    }

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Empolyee" modal className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVInput column={3} label="Employee Code:" required control={control} name="emp_Code" error={errors.emp_Code?.message} />
                    <JVInput column={3} label="First Name:" required control={control} name="first_Name" error={errors.first_Name?.message} />
                    <JVInput column={3} label="Last Name:" control={control} name="last_Name" error={errors.last_Name?.message} />

                    <JVInputMask mask={"(999) 999-9999"} column={3} label="Mobile:" required control={control} name="mob" error={errors.mob?.message} />
                    <JVInput column={3} label="E-Mail:" control={control} name="email" error={errors.email?.message} />
                    <JVDropdown column={3} label="Branch:" control={control} name="branch_ID" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" error={errors.branch_ID?.message} />

                    <JVDropdown column={3} label="Department:" control={control} name="department" optionLabel="department_Name" optionValue="department_ID" options={department} placeholder="Select Department" error={errors.department?.message} />
                    <JVDropdown column={3} label="Team Lead:" control={control} name="teamLead" optionLabel="user_Name" optionValue="login_ID" options={teamLead} placeholder="Select Team Lead" error={errors.teamLead?.message} />
                    <JVInput column={3} label="Adhar No:" control={control} name="adhar" error={errors.adhar?.message} />

                    <JVInput column={3} label="Pan:" control={control} name="pan" error={errors.pan?.message} />
                    <JVDate column={3} label="Date of Joining:" control={control} name="dateofJoining" error={errors.dateofJoining?.message} />
                    <JVDate column={3} label="End Date:" control={control} name="endDate" error={errors.endDate?.message} />

                    <JVInput column={3} label="Salary:" control={control} name="salary" error={errors.salary?.message} />
                    <JVInput column={3} label="Hangout:" control={control} name="hangout" error={errors.hangout?.message} />
                    <JVRadioBtn column={3} label="Status:" data={["Active", "InActive"]} control={control} name="empStatus" error={errors.empStatus?.message} />

                    <div style={{ margin: '10px 0', width: '100%' }}></div>
                    <div className="col-12 md:col-12 flex gap-4">
                        <Button className="field col md:col" loading={loading} label="SAVE" type="submit" disabled={saveDis}></Button>
                        <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div>
                </form>
            </Dialog>
        </>
    )
}